import styled from "styled-components"
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core"

export const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    border: 1px solid #aeaeae;
    transform: translateY(10px) !important;
    ox-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
      0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  }
`
